module.exports = "<div (click)=\"onSort()\">{{columnLabelName}}\n  <i class=\"fa fa-chevron-up\" *ngIf=\"sortDirection === 'desc'\" ></i>\n  <i class=\"fa fa-chevron-down\" *ngIf=\"sortDirection === 'asc'\"></i>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/sortable-column/sortable-column.component.html
// module id = ../../../../../src/app/sortable-column/sortable-column.component.html
// module chunks = main